import { createFileRoute, redirect } from "@tanstack/react-router";

import { AdminPage } from "@/features/admin/AdminPage";

export const Route = createFileRoute("/_app/admin")({
  beforeLoad: ({ context }) => {
    if (context.info.edition !== "local") throw redirect({ to: "/worklist" });
  },
  component: AdminPage,
});
